import { CloudUploadOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Col, Image, Modal, Row, Tooltip, Upload } from 'antd';
import PropTypes from 'prop-types';
import { Fragment, useCallback } from 'react';
import withStyles from 'react-jss';
import { useDispatch, useSelector } from 'react-redux';

import { setQualityCheckFiles } from '../Actions';
import { apiURL } from '../config';
import styles from '../styles';
import { getNewFileName } from '../utils';

const ShowFiles = props => {
  const {
    itemIndex,
    itemType,
    classes,
    watch,
    setValue,
    unregister,
    SetFileModal,
  } = props;

  const dispatch = useDispatch();

  const onRemove = image => {
    dispatch(setQualityCheckFiles(itemType, itemIndex, image, true));
  };

  const existFiles = watch(`${itemType}[${itemIndex}].files`);

  const onExistRemove = index => {
    const newImages = [...existFiles];

    newImages.splice(index, 1);

    setValue(`${itemType}[${itemIndex}].files`, newImages);
    unregister(`${itemType}[${itemIndex}].files[${newImages.length}]`);
  };

  const files = useSelector(state => state.qualityCheckFiles);

  const renderImage = (image, index) => {
    return (
      <Fragment key={index}>
        <Col xs={24} sm={7} md={6} lg={3} xl={2}>
          <Tooltip
            placement="topLeft"
            title={<DeleteOutlined onClick={() => onRemove(image)} />}
          >
            <Image
              src={URL.createObjectURL(image)}
              className={classes.jobchartImage}
            />
          </Tooltip>
        </Col>
        <Col xs={0} sm={1} />
      </Fragment>
    );
  };

  const renderExistImage = (image, index) => {
    return (
      <Fragment key={index}>
        <Col xs={24} sm={7} md={6} lg={3} xl={2}>
          <Tooltip
            placement="topLeft"
            title={<DeleteOutlined onClick={() => onExistRemove(index)} />}
          >
            <Image
              src={`${apiURL}/${image.key}`}
              className={classes.jobchartImage}
            />
          </Tooltip>
        </Col>
        <Col xs={0} sm={1} />
      </Fragment>
    );
  };

  const beforeUpload = useCallback(_file => {
    dispatch(
      setQualityCheckFiles(
        itemType,
        itemIndex,
        new File([_file], getNewFileName(_file.name), { type: _file.type })
      )
    );
    return false;
  }, []);

  return (
    <Modal
      title="Quality Check Files"
      visible
      centered
      closable={false}
      width={900}
      onOk={() => {
        SetFileModal(false);
      }}
      cancelButtonProps={{ style: { display: 'none' } }}
    >
      <Row>
        <Image.PreviewGroup>
          {existFiles?.length ? existFiles.map(renderExistImage) : null}
          {files[itemType][itemIndex]?.files?.length
            ? (files[itemType][itemIndex]?.files || []).map(renderImage)
            : null}
        </Image.PreviewGroup>
      </Row>
      <Row>
        <Col xs={4} className={classes.buttonContainer}>
          <Upload multiple beforeUpload={beforeUpload} fileList={[]}>
            <Button icon={<CloudUploadOutlined />}>Select Files</Button>
          </Upload>
        </Col>
      </Row>
    </Modal>
  );
};

ShowFiles.propTypes = {
  itemIndex: PropTypes.number.isRequired,
  itemType: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  watch: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  unregister: PropTypes.func.isRequired,
  SetFileModal: PropTypes.func.isRequired,
};

export default withStyles(styles)(ShowFiles);
